import type { QueryClient } from '@tanstack/query-core';
import type { Logger } from '@thinkalpha/ui-ioc/core/types/Logger';
import { getSecurityMasterEntriesQuery, getSymbolsMatchingPrefixQuery } from 'src/queries/securityMaster';
import type { SymbolSearchService } from 'src/services/SymbolSearchService';
import { container } from 'src/StaticContainer';
import type { ReactBindings } from 'src/types/bindings';

export class EquitiesSymbolSearchServiceImpl implements SymbolSearchService {
    #securityMasterService: ReactBindings['SecurityMasterService'];
    #queryClient: QueryClient;
    #log: Logger;

    constructor(securityMasterService: ReactBindings['SecurityMasterService'], queryClient: QueryClient) {
        this.#securityMasterService = securityMasterService;
        this.#queryClient = queryClient;
        this.#log = container.get('Logger').getSubLogger({ name: 'services:SymbolSearchService:Equities' });
    }

    async search(query: string) {
        if (TRACE) {
            this.#log.trace('search', { query });
        }

        if (!query) {
            return [];
        }

        const matchingSymbols = await this.#queryClient.fetchQuery(
            getSymbolsMatchingPrefixQuery(this.#securityMasterService, query),
        );

        const matchingEntries = await this.#queryClient.fetchQuery(
            getSecurityMasterEntriesQuery(this.#securityMasterService, matchingSymbols),
        );

        return matchingEntries.map((entry) => ({
            symbol: entry.symbol,
            info: entry,
        }));
    }

    get queryKey() {
        return ['EquitiesSymbolSearch'];
    }
}
